import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26 26",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.5,3.188C7.805,3.188,3.188,7.805,3.188,13.5S7.805,23.813,13.5,23.813S23.813,19.195,23.813,13.5 S19.195,3.188,13.5,3.188z M19,15h-4v4h-3v-4H8v-3h4V8h3v4h4V15z" })
});
export default SvgPlus;
